import { useContext, useState, useEffect, useRef} from 'react';

import { GlobalContext } from "../../../contexts/globalContext";

import PopupBodyComponent from '../common/PopupBodyComponent';
import PopupBaseComponent from '../common/PopupBaseComponent';
import LeftBodyComponent from '../common/LeftBodyComponent';

import membersAdd from '../../../graphics/Popups/Icon Members Add.png'
import ParticipantsListComponent from './ParticipantsListComponent';
import UsersListComponent from './UsersListComponent';


const AddPartipicantsComponent = () => {

    const [attachedParticipants, setAttachedParticipants] = useState([])

    const { socketRef, setAllUsers } = useContext(GlobalContext);

    useEffect(() => {
        socketRef.current.emit("GET_ALL_USERS", (users) => {
            setAllUsers(users)
        });
    },[])

    return (
        <PopupBaseComponent>
            <PopupBodyComponent style={{width: 1830, height: 1770, left: "40%"}}>
                <LeftBodyComponent givenWidth="800px" image={membersAdd} title="Add members to project" description="Select one or more members from the list below to add them to the project. The selected members will gain access to project resources and receive all relevant updates and notifications."/>
                <ParticipantsListComponent attachedParticipants={attachedParticipants} setAttachedParticipants={setAttachedParticipants}/>
            </PopupBodyComponent>
            <UsersListComponent attachedParticipants={attachedParticipants} setAttachedParticipants={setAttachedParticipants} />
        </PopupBaseComponent>
    );

}

export default AddPartipicantsComponent;